module.exports = __webpack_public_path__ + "img/K6.8f555ebe.jpg";